module.exports = __webpack_public_path__ + "static/media/instructor.ff2f7f00.png";